const isNotUndefinedString = (val: string | undefined): boolean =>
  val !== undefined && val !== 'undefined';

export default isNotUndefinedString;
